import * as Sentry from '@sentry/react';
import { user } from 'packages/lib/auth';

export const logError = (
  err: unknown,
  toConsole = true,
  obj?: unknown | undefined
): void => {
  void user().then((user) => {
    Sentry.captureException(user ? `[${user?.email}]${err}` : err);
  });
  Sentry.captureException(err);
  if (toConsole) {
    if (obj) console.warn(err, obj);
    else console.warn(err);
  }
};
